import { closeModal, loadAnoByIdCooperativa, loadAnoByIdJornada, loadDadosEscolaById, loadDadosEscolaByIdCoop, loadDadosEscolaByIdJornada, loadPeriodosById, openModal } from 'store/modules/EscolasActions'
import './index.scss'
import { TipoPrograma } from 'store/modules/EscolasTypes'
import { ProgramaEscola } from '..'
import { LoadedCoopEscola } from './listaPeriodo/listaPeriodoItem/cooperativa/Modal/ModalAddCoop/DocumentCoop/__types';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { useHabilitaCampoPrograma } from '../hooks/useDisablePrograma';
import { useEffect } from 'react';
import { ModalCadastroCooperativa } from 'components/ModalCadastroCooperativa';
import { ModalAddCoop } from './listaPeriodo/listaPeriodoItem/cooperativa/Modal/ModalAddCoop';
import { Button } from '@material-ui/core';
import { AddIcon } from 'assets/icons/AddIcon';
import languageValues from 'utils/LanguageUtils';
import UseCooperativa from '../hooks/useCooperativa';
import { ListaCooperativa } from './listaPeriodo/listaPeriodoItem/cooperativa/ListaCooperativa';
import "./index.scss"
import { ListaCooperativaPeriodo, ListaJornadaPeriodo, ListaUniaoFazAVidaPeriodo } from './listaPeriodo';

export const UniaoFazAVida = () => (
    <ProgramaEscola
        tipoPrograma={TipoPrograma.UniaoFazAVida}
        carregarDados={loadDadosEscolaById}
        carregarPeriodos={loadPeriodosById}
        ListaComponent={ListaUniaoFazAVidaPeriodo}
    />
);

export const CooperativaEscolar = () => {
    const { isDesabilitado } = useHabilitaCampoPrograma(TipoPrograma.CooperativaEscolar);
    const loadedCoops: LoadedCoopEscola[] = useSelector((state: RootState) => state.escolas.coopsEscolar);
    const modalContent = useSelector((state: RootState) => state.escolas.modalContent);
    const dispatch = useDispatch();
    const { handleCoopsFetch } = UseCooperativa();

    useEffect(() => {
        handleCoopsFetch();
    }, [handleCoopsFetch]);

    const openModalAdditionCooperative = (coop?: LoadedCoopEscola) => {
        dispatch(openModal(
            <ModalCadastroCooperativa
                title='Cadastro da cooperativa escolar'
                content={<ModalAddCoop coop={coop} />}
                open={true}
                close={() => dispatch(closeModal())}
            />
        ));
    };

    const modalCooperativa = loadedCoops.length > 0 && (
        <ListaCooperativa
            coopList={loadedCoops}
            openModalCooperative={openModalAdditionCooperative}
        />
    );

    const botaoExtra = (
        <Button
            disabled={isDesabilitado}
            className={'button_addCooperativa'}
            endIcon={<AddIcon />}
            onClick={() => openModalAdditionCooperative()}
            variant='contained'
        >
            {languageValues.pages.escolas.labels.CadastrarCooperativaEscolar}
        </Button>
    );

    return (
        <>
            <ProgramaEscola
                tipoPrograma={TipoPrograma.CooperativaEscolar}
                carregarDados={loadDadosEscolaByIdCoop}
                carregarPeriodos={loadAnoByIdCooperativa}
                ListaComponent={ListaCooperativaPeriodo}
                listaCooperativaEscolar={modalCooperativa}
                titulo={
                    <span className={isDesabilitado ? 'coop_titulo-desabilitado' : ''}>
                        Cadastro de cooperativas escolares
                    </span>
                }
                descricao={
                    <span className={isDesabilitado ? 'coop_descricao-desabilitado' : ''}>
                        Cadastre as cooperativas escolares presente em sua escola:
                    </span>
                }
                botaoExtra={botaoExtra}
            />


            {modalContent &&
                <div>{modalContent}</div>}
        </>
    );
};

export const JornadaEducacao = () => (
    <ProgramaEscola
        tipoPrograma={TipoPrograma.JornadaEducacao}
        carregarDados={loadDadosEscolaByIdJornada}
        carregarPeriodos={loadAnoByIdJornada}
        ListaComponent={ListaJornadaPeriodo}
    />
);



